import styled from 'styled-components'

export const FieldStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.space.xsmall};
`
